
import { motion } from "framer-motion";
import { useRef, useState } from "react";
import auth from "../../../helpers/auth";
import DatePicker from "react-datepicker";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import serverTimeHelper from "../../../helpers/serverTimeHelper";
import {
    dateNowByServer
} from "../../../helpers/date.js";

import axiosWithCacheConfig from "../../../helpers/axiosWithCacheConfig";

function Hide({ referendum, setReferendum, titleSlug, setStep, setShowContent }) {

    const serverTime = serverTimeHelper.get();
    const initServerTime = serverTimeHelper.clientTime();

    const reasonRef = useRef(null);
    const [displayContent, setDisplayContent] = useState(false);

    const initDate = {
        min: moment(dateNowByServer(serverTime, initServerTime)).utc().toDate(),
        max: moment(dateNowByServer(serverTime, initServerTime)).add(3, "months").utc().toDate(),
    };
    const [startDate, setStartDate] = useState(moment(dateNowByServer(serverTime, initServerTime)).toDate());
    const [endDate, setEndDate] = useState(moment(dateNowByServer(serverTime, initServerTime)).add(1, "day").toDate());
    const [status, setStatus] = useState('loaded');


    const initErrors = {
        start_date: null,
        end_date: null,
        reason: null,
        others: null,
    };
    const [errors, setErrors] = useState(initErrors);


    function onChangeStartDate(e) {
        setStartDate(e);
        setErrors({ ...errors, start_date: null, end_date: null, others: null });
        setEndDate(moment(e).add(1, "day").toDate());
        setStatus('loaded');
    }

    function onChangeEndDate(e) {
        setEndDate(e);
        setErrors({ ...errors, end_date: null, others: null });
        setStatus('loaded');
    }

    function setDateToUTC(date) {
        return moment(date).utc().format("YYYY-MM-DDT00:00:00.SSS[Z]");
    }

    function onChangeReason(e) {
        setErrors({ ...errors, reason: null, others: null });
        setStatus('loaded');
    }

    function onChangeBlockContent() {
        setDisplayContent((prev_checked) => !prev_checked);
    }

    function onSubmit(e) {
        e.preventDefault();
        setErrors(initErrors);
        let has_error = false;
        let temp_errors = { ...initErrors };
        let temp_status = status;

        let moderated = true;
        const dateNow = new Date(dateNowByServer(serverTime, initServerTime));

        let date_now_in_local = dateNow;
        let start_date_in_local = new Date(moment(startDate).utc().toString());
        let end_date_in_local = new Date(moment(endDate).utc().toString());

        let temp_reason = reasonRef.current.value.trim();
        if (temp_reason.length < 1) {
            temp_errors = { ...errors, reason: "Reason is required." };
            has_error = true;
        }

        // check if end date is past and if end_date is after start date
        if (end_date_in_local < date_now_in_local || start_date_in_local > end_date_in_local) {
            temp_errors = { ...errors, end_date: "Please select a valid end date." };
            has_error = true;
        }

        if (has_error) {
            setErrors(temp_errors);
            setStatus('error');
            return
        }

        if (temp_status === 'updating') return;
        setStatus('updating');
        setErrors(initErrors)


        let url = process.env.REACT_APP_ENVIRONMENT === "development" ? `http://${process.env.REACT_APP_HOST}:3004/op/v1/referendums/${titleSlug}/moderate` : `https://api.onepeople.online/op/v1/referendums/${titleSlug}/moderate`;
        axiosWithCacheConfig
            .post(url,
                {
                    action: "moderate",
                    referendum_hide_start_date: setDateToUTC(start_date_in_local),
                    referendum_hide_end_date: setDateToUTC(end_date_in_local),
                    reason: reasonRef.current.value,
                    display_content: displayContent,
                },
                {
                    headers: {
                        Authorization: `Bearer ${auth.getToken()}`,
                    },
                }
            )
            .then((res) => {
                if (res.data.success) {
                    setStatus('updated');
                    setStep('hidden');

                    if (
                        (date_now_in_local > start_date_in_local) &&
                        (end_date_in_local > date_now_in_local) &&
                        !referendum.moderated
                    ) {
                        setReferendum((old_ref) => {
                            return {
                                ...old_ref,
                                moderated: true,
                                moderated_reason: temp_reason,
                                display_content: displayContent,
                            };
                        })
                        setShowContent(displayContent)
                    } else {
                        if (referendum.moderated) {
                            setTimeout(() => {
                                window.location.href = `/referendums/${titleSlug}`;
                            }, 500)
                        }
                    }
                }
            })
            .catch((err) => {
                if (err?.response?.status === 400) {
                    let err_response = Object.assign({}, ...err.response.data.errors);
                    console.log(err_response)
                    setErrors({ ...errors, ...err_response });
                } else {
                    setErrors({ ...errors, others: "Something went wrong. Please try again." });
                }
                setStatus('error');
            })
    }


    return (
        <form className="px-4 moderation-form">
            <div className="col-12 row m-0 p-0">
                <div className="col-12 col-md-6 mt-2 mt-md-0 ps-0 pe-0 pe-md-1">
                    <div className="m-0 p-0 d-flex justify-content-between">
                        <label htmlFor="closing_date" className="input-text text-gray">
                            Start
                        </label>
                    </div>
                    <div className="position-relative d-select border-0 mt-1">
                        <DatePicker
                            id="closing_date"
                            dateFormat="dd/MM/yyyy"
                            className="px-2 w-100"
                            placeholderText="Date"
                            selected={startDate ?? undefined}
                            onChange={onChangeStartDate}
                            startDate={initDate.min}
                            minDate={initDate.min}
                            maxDate={initDate.max}
                            style={{ width: "100%" }}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faCalendarDays}
                            fontSize={"0.8rem"}
                            color="#3FA778"
                            aria-hidden="true"
                            style={{
                                position: "absolute",
                                right: "0.5rem",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                                zIndex: "5",
                            }}
                        />
                    </div>

                    <div className="m-0 p-0 text-left mt-1">
                        {errors.start_date && (
                            <p className="m-0 p-0 input-text input-error text-red">
                                {errors.start_date}
                            </p>
                        )}
                    </div>
                </div>
                <div className="col-12 col-md-6 mt-2 mt-md-0 ps-0 pe-0 ps-md-1">
                    <div className="m-0 p-0 d-flex justify-content-between">
                        <label htmlFor="closing_time" className="input-text text-gray">
                            End
                        </label>
                    </div>
                    <div className="position-relative d-select border-0 mt-1">
                        <DatePicker
                            id="closing_date"
                            dateFormat="dd/MM/yyyy"
                            className="px-2 w-100"
                            placeholderText="Date"
                            selected={endDate ?? undefined}
                            onChange={onChangeEndDate}
                            startDate={initDate.min}
                            minDate={initDate.min}
                            maxDate={initDate.max}
                            style={{ width: "100%" }}
                            onKeyDown={(e) => {
                                e.preventDefault();
                            }}
                        />
                        <FontAwesomeIcon
                            icon={faCalendarDays}
                            fontSize={"0.8rem"}
                            color="#3FA778"
                            aria-hidden="true"
                            style={{
                                position: "absolute",
                                right: "0.5rem",
                                top: "50%",
                                transform: "translateY(-50%)",
                                color: "#ccc",
                                zIndex: "5",
                            }}
                        />
                    </div>
                    {errors.end_date && (
                        <div className="m-0 p-0 text-left mt-1">
                            <p className="m-0 p-0 input-text input-error text-red">
                                {errors.end_date}
                            </p>
                        </div>
                    )}
                </div>
            </div>

            <div className="col-12 mt-4">
                <textarea
                    ref={reasonRef}
                    onChange={onChangeReason}
                    name="reason"
                    id="reason"
                    placeholder="What is the reason for moderation?"
                    rows={5}
                    className="form-control hl-border mt-1"
                ></textarea>
            </div>

            <div className="col-12 mt-3 d-flex justify-content-end align-items-center">
                <input
                    className="form-check-input position-relative me-2 hl-border mt-1"
                    style={{ top: "-0.125rem", fontSize: "1.2rem" }}
                    type="checkbox"
                    name="display-only"
                    id="display_only"
                    checked={displayContent}
                    onChange={onChangeBlockContent}
                />
                <label
                    className="form-check-label input-text text-gray"
                    htmlFor="display_only"
                    style={{ fontSize: "0.8rem" }}
                >
                    Display Content
                </label>
            </div>

            {(errors.others || errors.reason) && (
                <div className="m-0 p-0 text-left mt-1">
                    {errors.reason && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.reason}
                        </p>
                    )}
                    {errors.others && (
                        <p className="m-0 p-0 input-error text-red">
                            {errors.others}
                        </p>
                    )}
                </div>
            )}

            <div className="d-flex justify-content-center mt-4">
                <motion.input
                    initial={{}}
                    animate={
                        (status === 'updating' || status === 'error')
                            ? { backgroundColor: "#ccc", cursor: "not-allowed" }
                            : {}
                    }
                    onClick={onSubmit}
                    type="submit"
                    name="submit"
                    value="Submit"
                    className="bounce op-btn delete-btn"
                />
            </div>
        </form>
    )
}

export default Hide;